import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {ComponentsModule} from '../shared/components/components.module';
import {PipesModule} from "../shared/pipes/pipes.module";

import {Saseung3RoutingModule} from './saseung3-routing.module';

import {Saseung3Component} from './saseung3.component';
import {Saseung3DetailComponent} from './saseung3-detail/saseung3-detail.component';
import {Saseung3ItemComponent} from './saseung3-item/saseung3-item.component';
import {Saseung3HelpBtnComponent} from './help/saseung3-help-btn';
import {Saseung3HelpPopupComponent} from './help/saseung3-help-popup.component';


@NgModule({
  declarations: [
    Saseung3Component,
    Saseung3DetailComponent,
    Saseung3ItemComponent,
    Saseung3HelpBtnComponent,
    Saseung3HelpPopupComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ComponentsModule,
    PipesModule,
    Saseung3RoutingModule,
  ],
  exports: [
    Saseung3ItemComponent,
  ]
})
export class Saseung3Module {
}
